import styled from 'styled-components';

export const Cloud = styled.img`
    width: 10vw;
    padding: 0 2.5vh;
    height: 5vh;
    margin-top: ${props => props.marginTop};
    ${props => props.marginLeft ? `margin-left: ${props.marginLeft};` : ''};
`;
